import { render, staticRenderFns } from "./AgmsTable.vue?vue&type=template&id=6075453e"
import script from "./AgmsTable.vue?vue&type=script&lang=js"
export * from "./AgmsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports